/**
 * usePreConnect — pre-connect abort/session/remote-stream refs
 * Phase 4 (PRI-291): extracted from useStreamSession
 *
 * Owns: preConnectAbortRef, preConnectSessionIdRef, preConnectRemoteStreamRef
 *
 * The preConnect() and cancelPreConnect() functions stay in the orchestrator because they
 * coordinate signalling, WebRTC, and connection state across multiple sub-hooks.
 */

import { useRef } from 'react'

export interface UsePreConnectReturn {
  /** AbortController for the in-progress pre-connect; abort() to cancel */
  preConnectAbortRef: React.MutableRefObject<AbortController | null>
  /** Session ID chosen during pre-connect — used by startStream() fast path */
  preConnectSessionIdRef: React.MutableRefObject<string | null>
  /**
   * Remote stream received during pre-connect.
   * Stored so the fast path can start recording without waiting for a new onRemoteStream.
   */
  preConnectRemoteStreamRef: React.MutableRefObject<MediaStream | null>
}

export function usePreConnect(): UsePreConnectReturn {
  const preConnectAbortRef = useRef<AbortController | null>(null)
  const preConnectSessionIdRef = useRef<string | null>(null)
  const preConnectRemoteStreamRef = useRef<MediaStream | null>(null)

  return {
    preConnectAbortRef,
    preConnectSessionIdRef,
    preConnectRemoteStreamRef,
  }
}
